import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import type { WPublicNavItemView } from '@zola/svc-web-api-ts-client';
// import { useInView } from 'react-intersection-observer';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';
import { isDarkColor } from 'pages/publicStyleUtils/utils.styles';
import NavigationMenu from '../NavigationMenu';
import Banner from '../../Banner';
import HiddenWebsiteBanner from '../../HiddenWebsiteBanner';
import HiddenPageBanner from '../../HiddenPageBanner';
import { ThemeContext } from '../../../context';
import { Z_INDEX_MAP, Z_INDEX_NAV_KEY } from '../../../util/zIndexConstants';
import { mapFontValuesToSerializedStyles } from '../../../util/mappers';
import { StyledHeaderCart, Title, Container } from './DesktopHeader.styles';
import getPublicWebsiteHref from '../../../util/getPublicWebsiteHref';

type DesktopHeaderProps = {
  title?: string;
  navItems?: WPublicNavItemView[];
  slug?: string;
  showCart: boolean;
};

const DesktopHeader = ({ title, navItems, slug, showCart }: DesktopHeaderProps): JSX.Element => {
  const router = useRouter();
  const {
    wedding,
    components: { globalHeaderFontValues, backgroundColors },
  } = useContext(ThemeContext);
  const { public_theme_v2 } = wedding || {};
  const navHeaderFontStyles = public_theme_v2?.components?.NAV?.fonts?.HEADER?.[1];
  const navBackgroundColor = backgroundColors.nav;
  const headerEleStyles = css`
    padding-right: ${SPACING.MD};
    padding-left: ${SPACING.MD};
    margin-right: auto;
    margin-left: auto;
    z-index: ${Z_INDEX_MAP[Z_INDEX_NAV_KEY]};
    background-color: #${navBackgroundColor};
  `;

  const TitleContainer = styled.div`
    ${headerEleStyles}
    padding-top: 48px;
    text-align: center;
    position: relative;
    ${MEDIA_QUERY.MOBILE} {
      display: none;
    }
  `;

  const TitleStyles = css`
    a {
      ${mapFontValuesToSerializedStyles(globalHeaderFontValues, navHeaderFontStyles, true)}
    }
  `;

  // TODO: wrap website title
  const showNavLinks = (navItems || []).length > 1;
  return (
    <Container>
      <HiddenWebsiteBanner />
      <HiddenPageBanner />
      <Banner />
      {title && (
        <TitleContainer>
          <Title css={TitleStyles}>
            <a href={getPublicWebsiteHref(slug, '', router?.query)}>{title}</a>
          </Title>
          {showCart && <StyledHeaderCart isDarkMode={isDarkColor(backgroundColors.nav)} />}
        </TitleContainer>
      )}
      {showNavLinks && <NavigationMenu navItems={navItems} slug={slug} css={headerEleStyles} />}
    </Container>
  );
};

export default DesktopHeader;
